<template>
  <div class="d-flex justify-content-center mb-3">
    <ul class="nav nav-pills">
      <li class="nav-item">
        <router-link
          to="/laudos/visao"
          class="nav-link"
          :class="ativo == 'visao' ? 'active' : ''"
        >Visão Geral</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/laudos/lista"
          class="nav-link"
          :class="ativo == 'lista' ? 'active' : ''"
        >Lista de Trabalho</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["ativo"]
};
</script>